import { forwardRef } from 'react'
import CreateSearchRecordDialogComponent from './CreateSearchRecordDialogComponent'
import Utils from '../../utils/Utils'

export default forwardRef(Utils.connectLuruExtensions(CreateSearchRecordDialogComponent))
